import { render } from "./doctor-editblog.vue?vue&type=template&id=20d0bbcc"
import script from "./doctor-editblog.vue?vue&type=script&lang=js"
export * from "./doctor-editblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__